var _path, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 182,
    viewBox: "0 0 182 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 6208"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 6207"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 533",
    d: "M91 182C141.258 182 182 141.258 182 91C182 40.7421 141.258 0 91 0C40.7421 0 0 40.7421 0 91C0 141.258 40.7421 182 91 182Z",
    fill: "#ECECEC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_832_31930",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 182,
    height: 182
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 534",
    d: "M91 182C141.258 182 182 141.258 182 91C182 40.7421 141.258 0 91 0C40.7421 0 0 40.7421 0 91C0 141.258 40.7421 182 91 182Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_832_31930)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask Group 204"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_Confirmed_re_sef7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 5067",
    d: "M124.241 142.335L125.079 172.688C125.079 172.688 91.6127 146.488 82.7237 126.618C73.8347 106.748 90.5668 57.5938 90.5668 57.5938L127.693 77.9868L124.241 142.335Z",
    fill: "#FCC3C5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5068",
    d: "M51.8687 44L40.8877 45.046C40.8877 45.046 35.1357 57.596 52.9147 58.646L51.8687 44Z",
    fill: "#FCC3C5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5069",
    d: "M51.8687 63.3438L40.8877 64.3897C40.8877 64.3897 35.1357 76.9397 52.9147 77.9897L51.8687 63.3438Z",
    fill: "#FCC3C5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5070",
    d: "M51.8687 84.2598L40.8877 85.3058C40.8877 85.3058 35.1357 97.8558 52.9147 98.9058L51.8687 84.2598Z",
    fill: "#FCC3C5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5071",
    d: "M55.0074 105.178L44.0264 106.224C44.0264 106.224 38.2744 118.774 56.0534 119.824L55.0074 105.178Z",
    fill: "#FCC3C5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5072",
    d: "M46.5234 49.0379H47.3564V26.213C47.3564 22.7092 48.7483 19.3489 51.2258 16.8714C53.7034 14.3938 57.0637 13.002 60.5674 13.002H108.923C112.427 13.002 115.787 14.3938 118.265 16.8714C120.743 19.3489 122.134 22.7092 122.134 26.213V151.436C122.134 154.94 120.743 158.3 118.265 160.778C115.787 163.255 112.427 164.647 108.923 164.647H60.5634C57.0597 164.647 53.6994 163.255 51.2218 160.778C48.7443 158.3 47.3524 154.94 47.3524 151.436V65.2859H46.5234V49.0379Z",
    fill: "#0B1B4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5073",
    d: "M60.034 16.4375H66.347C66.0567 17.1492 65.9459 17.9214 66.0244 18.686C66.1029 19.4506 66.3682 20.1842 66.7969 20.8221C67.2257 21.46 67.8048 21.9827 68.4832 22.3441C69.1615 22.7055 69.9184 22.8945 70.687 22.8945H98.387C99.1556 22.8945 99.9124 22.7055 100.591 22.3441C101.269 21.9827 101.848 21.46 102.277 20.8221C102.706 20.1842 102.971 19.4506 103.05 18.686C103.128 17.9214 103.017 17.1492 102.727 16.4375H108.627C111.244 16.4375 113.753 17.477 115.603 19.3272C117.454 21.1774 118.493 23.6869 118.493 26.3035V151.344C118.493 153.96 117.454 156.47 115.603 158.32C113.753 160.17 111.244 161.21 108.627 161.21H60.034C57.4173 161.21 54.9079 160.17 53.0576 158.32C51.2074 156.47 50.168 153.96 50.168 151.344V26.3035C50.168 23.6869 51.2074 21.1774 53.0576 19.3272C54.9079 17.477 57.4173 16.4375 60.034 16.4375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4002",
    d: "M94.74 51.4688H73.918V56.4928H94.74V51.4688Z",
    fill: "#5557C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4003",
    d: "M95.7317 73.0586H72.9277V78.0826H95.7317V73.0586Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4004",
    d: "M109.778 83.8516H58.8809V88.8756H109.778V83.8516Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4005",
    d: "M109.778 94.6445H58.8809V99.6685H109.778V94.6445Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5074",
    d: "M169.641 158.418L152.005 132.107L149.913 89.2284L127.951 52.6284L121.676 36.9414C121.676 36.9414 107.034 38.5104 119.061 68.3164L124.029 84.2654C119.55 93.91 117.229 104.416 117.229 115.049V151.596C117.229 160.202 118.904 164.567 123.677 171.728L125.311 173.006L169.641 158.418Z",
    fill: "#FCC3C5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 532",
    d: "M84.3565 143.029C92.4116 143.029 98.9415 136.499 98.9415 128.444C98.9415 120.389 92.4116 113.859 84.3565 113.859C76.3014 113.859 69.7715 120.389 69.7715 128.444C69.7715 136.499 76.3014 143.029 84.3565 143.029Z",
    fill: "#5557C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5076",
    d: "M82.9666 134.602L78.6016 128.989L81.1396 127.015L83.2066 129.673L90.1886 122.301L92.5236 124.513L82.9666 134.602Z",
    fill: "white"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckEmail);
export default __webpack_public_path__ + "static/media/check_email.4e740c558d22941072ae8f1f24fe66fc.svg";
export { ForwardRef as ReactComponent };